import { getStoredCommandIds, setCommandActor } from "./command-library";
import { CommandName, } from "./command-library.types";
import { deleteAllKey, } from "./delete-commands.types";
import { validateParams } from "./param-validator";
import { getStartInfo } from "./start-info";
const paramDefinitionList = [
    {
        name: "commands",
        validate: (param) => typeof param === "string" && param.trim() !== "",
    },
];
function isDeleteCommand(command) {
    const { logger } = getStartInfo();
    const validationErrors = validateParams(command, paramDefinitionList);
    if (validationErrors.length === 0) {
        return true;
    }
    logger.reportAndLogError(new Error(`[delete-commands]: Invalid parameters received: ${validationErrors.join(" ")}`));
    return false;
}
export function isDeleteBehavior(candidate) {
    return (candidate !== null &&
        typeof candidate === "object" &&
        "commandIds" in candidate);
}
function getBehavior(command) {
    if (!isDeleteCommand(command)) {
        return null;
    }
    const commands = command.commands.trim();
    let commandIds;
    if (commands === deleteAllKey) {
        commandIds = getStoredCommandIds();
    }
    else {
        commandIds = commands.split(",").map((id) => id.trim());
    }
    return { commandIds };
}
function getContent() {
    return {};
}
export function setDeleteCommandHandler(handler) {
    setCommandActor(CommandName.deleteCommands, {
        clearCommands: () => { },
        getBehavior,
        getContent,
        handleCommand: handler,
        isValidCommand: isDeleteCommand,
        onCommandsProcessed: () => { },
    });
}
